var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aa-return-policy"},[_c('v-container',[_c('div',{staticClass:"aa-return-policy__wrap"},[_c('h1',[_vm._v("Return Policy")]),(this.field)?_c('div',{domProps:{"innerHTML":_vm._s(this.field.content)}}):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }